import { render, staticRenderFns } from "./Dscl.vue?vue&type=template&id=2d1ac81e"
import script from "./Dscl.vue?vue&type=script&lang=js"
export * from "./Dscl.vue?vue&type=script&lang=js"
import style0 from "./Dscl.vue?vue&type=style&index=0&id=2d1ac81e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports